// @flow

import { Campaign } from './Campaign'

export const Chatbot = Campaign
